import surgalt1 from "../images/events/dotood-surgalt/1/1.png";
import surgalt1a from "../images/events/dotood-surgalt/1/2.png";
import surgalt1b from "../images/events/dotood-surgalt/1/3.png";
import surgalt2 from "../images/events/dotood-surgalt/2/1.png";
import surgalt2a from "../images/events/dotood-surgalt/2/2.png";
import surgalt2b from "../images/events/dotood-surgalt/2/3.png";
import surgalt3 from "../images/events/dotood-surgalt/3/1.png";
import surgalt4 from "../images/events/dotood-surgalt/4/1.png";
import surgalt4a from "../images/events/dotood-surgalt/4/2.png";
import surgalt4b from "../images/events/dotood-surgalt/4/3.png";
import surgalt5 from "../images/events/dotood-surgalt/5/1.jpg";
import surgalt5a from "../images/events/dotood-surgalt/5/2.jpg";
import surgalt5b from "../images/events/dotood-surgalt/5/3.jpg";
import surgalt6 from "../images/events/dotood-surgalt/6/1.jpg";
import surgalt6a from "../images/events/dotood-surgalt/6/2.jpg";
import surgalt6b from "../images/events/dotood-surgalt/6/3.jpg";

const dotoodVilAjillagaa = [
  {
    Id: "1",
    img1: surgalt1,
    img2: surgalt1a,
    img3: surgalt1b,
    bigtitle: "🕺Эрүүл амьдрал идэвхитэй хөдөлгөөн💃🏼",
    title: "Бүжгийн сургалт явууллаа",
    slug: "1",
    slugMn: "бүжиг-сургалт",
    features: "Эрүүл мэндийг дэмжих",
    address: "233 Main St, New York",
    description:
      "Итгэгчдийнхээ бие бялдар, эрүүл мэндийг дэмжих зорилгоор мэргэжлийн багш сургагч энэхүү сургалтыг зохион явуулдаг билээ. ",
    description2:
      "Сургалтад насны ангилал харгалзахгүй нэгдэж, бүжгийн энгийн хөдөлгөөнүүдийг суралцаж эхлэв. Хөгжмийн аялгуу, багш нарын урам зоригтой зааварчилгаа, оролцогчдын инээд хөөрөөр дүүрэн байлаа.",
  },
  {
    Id: "2",
    img1: surgalt2,
    img2: surgalt2a,
    img3: surgalt2b,
    bigtitle: "📣 “БИБЛИЙН ДҮРҮҮД” – ДҮРД ХУВИРАХ ГАЙХАЛТАЙ ӨДӨР ✨",
    title: "Библийн түүх, дүр",
    slug: "2",
    slugMn: "түүх-дүр",
    features: "Нэгдэж ажиллах",
    address: "233 Main St, New York",
    description:
      "Библийн түүх, дүрүүдээр дамжуулан итгэгч нар нэгдэн баг болж ажиллан дүрүүдийн онцлогийг гаргасан, тухайн дүр түүхээ илүү сайн ойлгосон цаг мөч боллоо.",
    description2:
      "Энэхүү үйл ажиллагааны зорилго нь: Библийн мэдлэгийг баяжуулах, багаар ажиллах ур чадварыг хөгжүүлэх, бүтээлч сэтгэлгээг дэмжих билээ. Библид гардаг алдартай түүхүүд болон дүрүүдийг сонгон, хувцаслалт, тайзны үзүүлбэр, уран бүтээлч сэтгэлгээгээрээ өрсөлдсөн юм. Эстер хатан, Давид ба Голиат, Ноа ба хөвөгч авагч авдар, Мосе улаан тэнгисийг хоёр хуваасан түүх зэрэг олон сонирхолтой үзүүлбэр үзэгчдийн уухай, алга ташилтаар дүүрэн байлаа.",
  },
  {
    Id: "3",
    img1: surgalt3,
    bigtitle: "Залуучууддаа илтгэх урлагийн сургалт зохион байгууллаа🗨️ 🎤",
    title: "Илтгэх урлагийн сургалт",
    slug: "3",
    slugMn: "илтгэх урлаг",
    features: "ярих чадварт суралцах",
    address: "233 Main St, New York",
    description:
      "Илтгэх урлаг нь зөвхөн тайзан дээр бус, өдөр тутмын ажил, харилцаанд чухал ур чадвар билээ. Залуучуудыг өөртөө итгэх итгэлээ нэмэгдүүлж, хэл яриагаараа нөлөөлөх чадвараа хөгжүүлэхэд сургалтын зорилго оршино.",
    description2:
      "Илтгэх урлагын давуу талууд нь амжилттайгаар бусдад өөрийгөө илэрхийлэх, өөртөө илүү итгэлтэй болох, харилцааны ур чадвар нэмэгдэх, сэтгэх хурд сайжрах зэрэг олон байдаг билээ.",
  },
  {
    Id: "4",
    img1: surgalt4,
    img2: surgalt4a,
    img3: surgalt4b,
    bigtitle: "Хөдөлмөр бүтээлийн үзэсгэлэн",
    title: "Хөдөлмөр бүтээлийн үзэсгэлэн",
    slug: "4",
    slugMn: "үзэсгэлэн",
    features: "бүтээлч байдал",
    address: "233 Main St, New York",
    description:
      "Итгэл найдвар, урам зоригийг түгээх гараар урласан Библийн түүхийн үзэсгэлэн болж өнгөрлөө. Энэхүү үзэсгэлэнд Библийн онцлох түүхүүдийг дэлгэн гараар хийсэн бүтээлүүдээр дүрслэн харуулжээ.",
    description2:
      "Үзэсгэлэнгийн онцлог нь бүх зүйлсийг гарын ур дүй, сэтгэл шингэсэн бүтээлүүдээр илэрхийлсэнд оршиж байна. Элс, хайрга, цаасан урлал, мод, шавар болон бусад гарын доорх материалуудаар урласан бүтээлүүд Библийн үйл явдлыг амьд мэт сэтгэгдэл төрүүлэхүйц бүтээлүүд гаржээ.",
  },
  {
    Id: "5",
    img1: surgalt5a,
    img2: surgalt5,
    img3: surgalt5b,
    bigtitle: "Ахмадуудын хүлээн авалт",
    title: "Ахмадуудаа хүндлэх",
    slug: "5",
    slugMn: "ахмадын сар шинийн хүлээн авалт",
    features: "хүндлэл",
    address: "233 Main St, New York",
    description:
      "Сар шинийн баярыг тохиолдуулан сүмийн ахмадуудд баярын мэнд дэвшүүлэн хүлээн авалт хийж үйлчлэв.",
    description2:
      "Хүрэлцэн ирсэн ахмад бүртээ сүү болон гарын бэлэг гардуулсан билээ.",
  },
  {
    Id: "6",
    img1: surgalt6,
    img2: surgalt6a,
    img3: surgalt6b,
    bigtitle: "Хөрсний багийн тэмцээн амжилттай зохион байгууллаа",
    title: "Хөрсний багийн тэмцээн",
    slug: "6",
    slugMn: "хөрс-багийн-тэмцээн",
    features: "заах чадвараа өсгөх",
    address: "233 Main St, New York",
    description:
      "Сүмийн хэмжээнд нийт итгэгчдийнхээ дундаас шалгаран гарч ирсэн шилдэг 8 багийн дундах хөрсний багийн тэмцээний амжилттай зохион байгууллаа. Уг тэмцээн эхний шат тест, хоёрдугаар шат жүжигчилсэн тоглолт, гуравдугаар шат илтгэл гэсэн 3 үе шатны дүнгээр аваргууддаа шалгаруулсан билээ.",
  },
];

export default dotoodVilAjillagaa;
